<template>
  <div class="location-preview clearfix col-12 toggle-hover relative pb2 md-pb0">
    <router-link class="block" :to="{ name: 'Location', params: { slug: data.slugs[0] }}">
      <div class="clearfix">
        <div class="xs-hide sm-hide col md-col-2 lg-col-2 border-right">
          <img class="block" v-lazy="silhouette" width="640" height="640" />
        </div>
        <div class="col col-12 md-col-10 pt2">
          <div class="clearfix">
            <div class="col col-4 md-col-4 lg-col-2 md-px3">
              <span v-text="processDate(location_data.date)"></span><br/>
              <span class="show-hover" v-text="getText(location_data.times)"></span>
              <span class="md-show lg-hide block pt1"><span v-text="weatherText"></span></span>
            </div>
            <div class="col col-8 md-col-8 lg-col-4 px3">
              <span v-text="getText(location_data.title)"></span> (<span v-text="getText(location_data.beach_title)"></span>)
            </div>
            <div class="col col-4 px3 xs-hide sm-hide md-hide">
              <span v-if="text_title">
                <em v-text="text_title"></em> by <span v-text="text_author"></span>
              </span>
              <span v-else>&nbsp;</span>
            </div>
            <div class="col col-2 xs-hide sm-hide md-hide pl3 pr0 right-align" v-text="weatherText"></div>
          </div>
        </div>
      </div>
    </router-link>
    <span v-if="isNext" class="xs-hide sm-hide md-hide next badge absolute green">
      <div class="ring-container">
        <div class="ringring"></div>
        <div class="circle"></div>
      </div>
      <span>Next Event</span>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getHtml, getText, processDate } from '@/utils'

export default {

  name: 'LocationPreview',

  data () {
    return {

    }
  },

  props: ['data', 'weather'],

  computed: {
    ...mapGetters([
      'nextEvent'
    ]),
    isNext() {
      if (this.nextEvent) {
        return this.nextEvent.id == this.data.id
      } else {
        return false
      }
    },
    location_data() {
      return this.data.data
    },
    silhouette() {
      return this.location_data.silhouette.url
    },
    weatherText () {
      if (this.weather) {
        return `${Math.round(this.weather.apparentTemperature)}° ${this.weather.summary.replace('Dangerously', '')}`
      } else {
        return ''
      }
    },
    text_title () {
      if (this.location_data.text.hasOwnProperty('data') && this.location_data.text.data.hasOwnProperty('title')) {
        return this.getText(this.location_data.text.data.title)
      } else {
        return ""
      }
    },
    text_author () {
      if (this.location_data.text.hasOwnProperty('data') && this.location_data.text.data.hasOwnProperty('author')) {
        return this.getText(this.location_data.text.data.author)
      } else {
        return ""
      }
    }
  },

  methods: {
    getHtml,
    getText,
    processDate
  }
}
</script>

<style lang="css" scoped>
  .location-preview {
    border-bottom: 1px solid var(--black);

    img {
      max-width: 100%;
      width: 100%;
      height: auto;
    }
  }
</style>
